import { render, staticRenderFns } from "./Stocktakes.vue?vue&type=template&id=51c0df10&scoped=true&"
import script from "./Stocktakes.vue?vue&type=script&lang=js&"
export * from "./Stocktakes.vue?vue&type=script&lang=js&"
import style0 from "./Stocktakes.vue?vue&type=style&index=0&id=51c0df10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0df10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VSelect,VTextField})
